/**
 * Looping fake TTS envelope for Orb Lab.
 *
 * Live exam sessions do this with an AnalyserNode on the agent MediaStreamTrack
 * (RMS of the lower spectrum → smoothed amp + peak-hold punch). The lab
 * cannot mint a real track, so this phrase-shaped 0–1 amplitude stands in:
 * voiced bursts with attack/release, ~5 Hz syllable ripple, then a pause.
 */

export const FAKE_SPEECH_CYCLE_MS = 5200;

const VOICED_WINDOWS_MS: ReadonlyArray<readonly [number, number]> = [
  [80, 420],
  [500, 980],
  [1100, 1720],
  [1880, 2280],
  [2400, 3180],
  [3380, 3720],
];

function voicedGate(cycleMs: number): number {
  for (let i = 0; i < VOICED_WINDOWS_MS.length; i += 1) {
    const [start, end] = VOICED_WINDOWS_MS[i];
    if (cycleMs >= start && cycleMs < end) {
      const local = (cycleMs - start) / (end - start);
      return Math.sin(local * Math.PI);
    }
  }
  return 0;
}

function wrapCycle(elapsedMs: number): number {
  return ((elapsedMs % FAKE_SPEECH_CYCLE_MS) + FAKE_SPEECH_CYCLE_MS) % FAKE_SPEECH_CYCLE_MS;
}

/** 0–1 RMS-like amplitude. Silence between phrases is exactly 0. */
export function sampleFakeSpeechAmp(elapsedMs: number): number {
  const cycleMs = wrapCycle(elapsedMs);
  const gate = voicedGate(cycleMs);
  if (gate <= 0) return 0;
  const syllable = (0.5 + 0.5 * Math.sin((elapsedMs / 1000) * Math.PI * 10.5)) ** 2.2;
  return Math.min(1, gate * (0.22 + 0.78 * syllable));
}
